import { useState } from "react";
import api from "../../../../../../services/api";
import MessageSuccess from "../../../../../../messages/messageSuccess";
import MessageError from "../../../../../../messages/messageError";
import RegisterAccess from "../../../../../../utils/registerAccess";
import HeaderSession from "../../../../../../utils/headerSession";
import ButtonLeft from "../../../../../../utils/buttonLeft";
import { Card, Checkbox, Container, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import * as yup from "yup"; // VALIDACAO
import { useDispatch } from "react-redux";
import DocsMedicamentosControladosInternacionalmenteAnexo from "./docsMedicamentosControladosInternacionalmenteAnexo";
import DocsEquipamentoAnexo from "./docsEquipamentoAnexo";
import DocsMedicamentosControladosNacionaisAnexo from "./docsMedicamentosControladosNacionaisAnexo";
import DocsMedicamentosNormalAnexo from "./docsMedicamentosNormalAnexo";
import DocsReagentesTDRsAnexo from "./docsReagentesTDRsAnexo";
import DocsSuplementoAlimentarAnexo from "./docsSuplementoAlimentarAnexo";
import { CountryDropdown } from "react-country-region-selector";
import { DialogActions, makeStyles } from "@material-ui/core";
import PontosEntrada from "../../../../../../utils/pontosEntrada";
import SearchSolicitacaoImportacao from "../../../../../../pages/home/services/importacaoExportacao/searchSolicitacaoImportacao";
import InputDocUpload from "../../../../../../utils/inputFileUpload/inputDocUpload";
import AlertEdit from "../../../../../../utils/alertEdit";

const useStyles = makeStyles((theme) => ({
  inputPais: {
    padding: 15,
    borderRadius: 4,
    borderColor: "#e1e1e1",
    width: "100%",
    // border: "dashed",
  },
}));

export default function FormSoliciteDesalfandegamentoDirecto() {
  const navigate = useNavigate();
  const classes = useStyles();
  const dispatch = useDispatch();
  const [solicitacao, setSolicitacao] = useState("");
  const [message, setMessage] = useState("");
  const [messageError, setErrorMessage] = useState("");
  const [open, setOpen] = useState(false);
  const { produto } = useParams();
  const imputLigth = true;
  const fullWidth = true;

  async function HandleChangeFile(file, name) {
    setSolicitacao((prevCadastro) => ({ ...prevCadastro, [name]: file }));
  }

  // function handleChange(e) {
  //   e.target.files
  //     ? setSolicitacao({ ...solicitacao, [e.target.name]: e.target.files[0] })
  //     : setSolicitacao({ ...solicitacao, [e.target.name]: e.target.value });
  // }

  function handleChange(e) {
    const { name, type, checked, value, files } = e.target;

    if (type === 'checkbox') {
      setSolicitacao({ ...solicitacao, [name]: checked });
    } else if (files) {
      setSolicitacao({ ...solicitacao, [name]: files[0] });
    } else {
      setSolicitacao({ ...solicitacao, [name]: value });
    }
  }

  async function createSolicitacaoDesalfandegamento() {
    const formData = new FormData();

    formData.append("numeroPorte", solicitacao?.numeroPorte);
    formData.append("numFatura", solicitacao?.numFatura);
    formData.append("destino", solicitacao?.destino);
    formData.append("pontoEntrada", solicitacao?.pontoEntrada);
    formData.append("numeroImportador", solicitacao?.numeroImportador);
    formData.append("paisOrigem", solicitacao?.paisOrigem);
    formData.append("endereco", solicitacao?.endereco);
    formData.append("fornecedorNome", solicitacao?.fornecedorNome);
    formData.append("contemPC", solicitacao?.produtoControlado ?? false);
    formData.append("termolabeis2Ca8C", solicitacao?.termolabeis2Ca8C ?? false);
    formData.append("ate15C", solicitacao?.termolabiel_ate_15 ?? false);
    formData.append("tipoCertificado", produto);
    formData.append("emolumentoId", "67b89a3a8d1b919f2318ed5c");

    // Docs
    formData.append("solicitacao", solicitacao?.solicitacao ?? '') //
    formData.append("cartaPorteBl", solicitacao?.cartaPorteBl ?? ""); //
    formData.append("certificadoCQL", solicitacao?.certificadoCQL ?? ""); //
    formData.append("certificadoOP", solicitacao?.certificadoOP ?? ""); //
    // formData.append("folhetoILP", solicitacao?.folhetoILP ?? '') //
    formData.append("faturaFinal", solicitacao?.faturaFinal ?? ""); //
    formData.append("faturaEmolumento", solicitacao?.faturaEmolumento ?? ""); //
    formData.append("CertificadoAnaliticoLote", solicitacao?.CertificadoAnaliticoLote ?? "");

    if (solicitacao?.produtoControlado) {
      formData.append("certificadoExportacao", solicitacao?.certificadoExportacao ?? "");
      formData.append("certificadoProdutoControlado", solicitacao?.certificadoProdutoControlado ?? "");
    }

    if (produto === "Suplemento-Alimentar") {
      formData.append("declaracaoExclusividade", solicitacao?.declaracaoExclusividade ?? "");
    }

    // if (produto === 'Produtos-controlados-nacionais') {}
    // if (produto === 'Medicamento-Normal') { }
    // if (produto === 'Equipamento') {}
    // if (produto === 'Reagentes-TDRs') {}

    setOpen(true);
    setErrorMessage("");
    setMessage("");

    await api
      .post("/declaracao-desalfandegamento-directo/register", formData)
      .then((res) => {
        setMessage(res.data.msg);
        dispatch({
          type: "alert",
          payload: { alert: "Solicitação foi enviada com sucesso.!" },
        });

        // console.log(res)
        navigate(
          `/solicitar/desalfangamento/add-item/${res.data.solicitacaoImportacaoId}`
        );
      })
      .catch((error) => {
        setErrorMessage(error.response.data.message);
        // console.log(error)
      })
      .finally(() => setOpen(false));
  }

  async function validate() {
    setErrorMessage('');

    const schema = yup.object().shape({
      faturaEmolumento: yup
        .string("Necessário fazer o upload da Factura de pagamento de emolumento Armed")
        .required("Necessário fazer o upload da Factura de pagamento de emolumento Armed"),

      faturaFinal: yup
        .string("Necessário fazer o upload da Factura Final dos produtos importados, na língua portuguesa")
        .required("Necessário fazer o upload da Factura Final dos produtos importados, na língua portuguesa"),

      // folhetoILP: yup.string("Necessário fazer o upload dos folhetos informativos em língua portuguesa").required("Necessário fazer o upload dos folhetos informativos em língua portuguesa"),
      // certificadoOP: yup.string("Necessário fazer o upload do Certificado de Origem dos produtos").required("Necessário fazer o upload do Certificado de Origem dos produtos"),
      // certificadoCQL: yup.string("Necessário fazer o upload do Certificado de controlo de qualidade por lotes").required("Necessário fazer o upload do Certificado de controlo de qualidade por lotes"),
      // cartaPorteBl: yup.string("Necessário fazer o upload da Carta de porte ou BL").required("Necessário fazer o upload da Carta de porte ou BL"),
      // solicitacao: yup.string("Necessário fazer o upload da carta dirigida à Armed").required("Necessário fazer o upload da carta dirigida à Armed"),

      pontoEntrada: yup
        .string("Necessário selecionar o ponto de entrada")
        .required("Necessário selecionar o ponto de entrada"),

      destino: yup
        .string("Necessário selecionar o destino dos produtos")
        .required("Necessário selecionar o destino dos produtos"),

      numFatura: yup
        .string("Necessário inserir o número de factura emitida pela Armed")
        .required("Necessário inserir o número de factura emitida pela Armed"),

      numeroPorte: yup
        .string("Necessário inserir o número de porte")
        .required("Necessário inserir o número de porte"),

      // ➕ Validação condicional
      certificadoProdutoControlado: yup
        .string("Necessário fazer o upload do certificado de produto controlado")
        .when("produtoControlado", {
          is: true,
          then: schema =>
            schema.required("Necessário fazer o upload do certificado de produto controlado"),
          otherwise: schema => schema.notRequired()
        })
    });

    try {
      await schema.validate(solicitacao, { abortEarly: false });
      createSolicitacaoDesalfandegamento();
    } catch (error) {
      setErrorMessage(error.errors);
    }
    return false;
  }
  return (
    <div>
      <RegisterAccess page={"solicitação de desalfandegamento"} />

      <Container style={{ minHeight: "70vh" }}>
        <HeaderSession title={`SOLICITAÇÃO DE DESALFANDEGAMENTO DE ${produto?.toUpperCase()}`} />
        {message && <MessageSuccess message={message} />}
        {messageError && <MessageError message={messageError} />}

        <>
          {solicitacao?.produtoControlado && <AlertEdit texto={'Caso não tenha o certificado de produto controlado deverá primeiro fazer a solicitação.'} />}

          <DialogActions>
            <div style={{ maxWidth: 560 }}>
              <small><b>OBS:</b> Caso tenha feito a solicitação de importação, inserira aquí o ID da solicitação.</small>
              <SearchSolicitacaoImportacao />
            </div>
          </DialogActions>

          <Typography variant="h5" m={2}>
            Preenche o formulário:
          </Typography>

          <Card style={{ padding: 10 }}>
            <Grid container>
              <Grid xs={12} md item m>
                <TextField
                  type="text"
                  label="Nº de Importador"
                  fullWidth
                  name="numeroImportador"
                  variant="outlined"
                  onChange={handleChange}
                />
              </Grid>

              <Grid xs={12} md item m>
                <TextField
                  type="text"
                  label="Nº da Factura (Emolumento Armed)"
                  fullWidth
                  name="numFatura"
                  variant="outlined"
                  onChange={handleChange}
                />
              </Grid>
            </Grid>

            <Grid container>
              <Grid xs={12} md item m>
                <PontosEntrada handleChange={handleChange} />
              </Grid>

              <Grid xs={12} md item m>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Destino</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Destino"
                    name="destino"
                    onChange={handleChange}
                  // defaultValue={addItem?.moedas ?? ''}
                  >
                    {/* <MenuItem value="" disabled>
                      ...
                    </MenuItem> */}
                    <MenuItem value="Comercialização">Comercialização</MenuItem>
                    <MenuItem value="Doação">Doação</MenuItem>
                    <MenuItem value="Uso pessoal">Uso pessoal</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container>
              <Grid xs={12} md item m>
                <TextField
                  type="text"
                  label="Nº de carta de porte/BL"
                  fullWidth
                  name="numeroPorte"
                  variant="outlined"
                  onChange={handleChange}
                />
              </Grid>

              <Grid xs={12} md item m marginTop={2}>
                <FormControlLabel style={{ marginTop: '-12px' }} control={<Checkbox
                  name="produtoControlado"
                  onChange={handleChange}
                  checked={solicitacao?.produtoControlado || false} />} label="Contém produto controlado"
                />
                <FormControlLabel style={{ marginTop: '-12px' }} control={<Checkbox
                  name="termolabeis2Ca8C"
                  onChange={handleChange}
                  checked={solicitacao?.termolabeis2Ca8C || false} />} label="Termolábéis: 2• a 8•C"
                />
                <FormControlLabel style={{ marginTop: '-15px' }} control={<Checkbox
                  name="termolabiel_ate_15"
                  onChange={handleChange}
                  checked={solicitacao?.termolabiel_ate_15 || false} />} label="Termolábéis atê 15•C"
                />
              </Grid>
            </Grid>

            {/* <hr style={{ border: '1px solid #c43ab9', marginTop: 10 }} /> */}
            <Typography align="center" m={2} color={"secondary"}>
              DADOS DA ORIGEM
            </Typography>

            <Grid container>
              <Grid xs={12} md item m>
                <TextField
                  type="text"
                  label="Fornecedor"
                  fullWidth
                  name="fornecedorNome"
                  variant="outlined"
                  onChange={handleChange}
                />
              </Grid>

              <Grid xs={12} md item m>
                <CountryDropdown
                  style={{
                    color: "gray",
                    border: '1px solid gray-100',
                    backgroundColor: "transparent",
                    height: "100%",
                  }}
                  className={classes.inputPais}
                  value={solicitacao?.paisOrigem ?? ""}
                  onChange={(pais) =>
                    setSolicitacao({ ...solicitacao, paisOrigem: pais })
                  }
                  defaultOptionLabel="Pais de Origem"
                />
              </Grid>
            </Grid>

            <Grid container>
              <Grid xs={12} md item m>
                <TextField
                  type="text"
                  label="Endereço"
                  fullWidth
                  name="endereco"
                  variant="outlined"
                  onChange={handleChange}
                />
              </Grid>

              <Grid xs={12} md item m>
                {/* <TextField
                  type="text"
                  label="Nº da Fatura Final"
                  fullWidth
                  name="numFaturaFinal"
                  variant="outlined"
                  onChange={handleChange}
                /> */}
              </Grid>
            </Grid>

            {/* ANEXAR DOCUMENTOS */}
            <Typography align="center" m={2} color={"secondary"}>
              ANEXAR DOCUMENTOS{" "}
            </Typography>

            {produto === "Produtos-de-controle-internacional" && (
              <DocsMedicamentosControladosInternacionalmenteAnexo
                HandleChangeFile={HandleChangeFile}
              />
            )}
            {produto === "Produtos-de-controle-nacional" && (
              <DocsMedicamentosControladosNacionaisAnexo
                HandleChangeFile={HandleChangeFile}
              />
            )}
            {produto === "Medicamentos" && (
              <DocsMedicamentosNormalAnexo
                HandleChangeFile={HandleChangeFile}
              />
            )}
            {produto === "Suplemento-Alimentar" && (
              <DocsSuplementoAlimentarAnexo
                HandleChangeFile={HandleChangeFile}
              />
            )}
            {produto === "Equipamento" && (
              <DocsEquipamentoAnexo HandleChangeFile={HandleChangeFile} />
            )}
            {produto === "Reagentes-TDRs" && (
              <DocsReagentesTDRsAnexo HandleChangeFile={HandleChangeFile} />
            )}


            {/* CASO EXISTRIR PRODUTO CONTROLADO NA SOLICITACAO */}
            {solicitacao?.produtoControlado &&
              <Grid container>
                <Grid xs={12} sm={6} item>
                  <InputDocUpload
                    imputLigth={imputLigth}
                    fullWidth={fullWidth}
                    onFileSelect={HandleChangeFile}
                    inputName={'certificadoProdutoControlado'}
                    inputDescription={'Certificado de produto controlado'}
                    inputTitle={'Certificado de produto controlado'}
                  />

                </Grid>

                <Grid xs={12} sm={6} item>
                  <InputDocUpload
                    imputLigth={imputLigth}
                    fullWidth={fullWidth}
                    onFileSelect={HandleChangeFile}
                    inputName={'certificadoExportacao'}
                    inputDescription={'Certificado de exportação'}
                    inputTitle={'Certificado de exportação (Se aplicavel)'}
                  />
                </Grid>
              </Grid>
            }

            <ButtonLeft
              title={"Submeter"}
              funcao={validate}
              disabled={!solicitacao || open}
              load={open}
            />
          </Card>
        </>
      </Container>
      <br />
    </div>
  );
}
